<script>
/* jshint esversion: 6 */
import { computed, watch, inject } from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default{
    name: 'RadioField',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'disabled': {type: Boolean},
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
	},
    setup(props) {
        const validateChild = inject('validateChild');

        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep: true});

        function isInModel(itemId) {
            if (itemId === props.model[props.schema.model]) {
                return true;
            }
            return false;
        }

        return {
            isInModel
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldRadio(
       :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        .form-group.row.gy-2.gx-3-align-items-left
            .col-sm-12 
                label(
                    :for="id" 
                    v-if="schema.label && schema.label.length > 0"
                ) 
                    |{{ schema.label }}
                    span.redAst(v-if="schema.required === true && schema.labelAsterisk === true") *
        .form-group.row.gy-2.gx-3-align-items-left.radioStyle
            .row.compStyle(
                :style="[schema.inline === true ? `display: flex; flex-wrap: wrap; justify-content: ${schema.flexJustify};` : '', schema.overflow === true ? 'overflow:scroll' : '']"
                :class="schema.containerClass"
            )
                template(v-if="schema.radioType === 'round'")
                    div.radioSingleItem(:class="schema.inline === true ? `${schema.size}` : 'col-12'" v-for="item, index in schema.values")
                        label.smallLabel(
                            :for="`${id}_${index}`" 
                            :style="[disabled === true ? 'pointer-events:none' : '']"
                        )
                            input(
                                type="radio" 
                                :name="schema.model" 
                                :value="item.id" 
                                :id="`${id}_${index}`"
                                v-model="model[schema.model]"
                                :class="schema.errorShow === true ? 'inputred' : ''"
                                :style="[disabled === true ? 'pointer-events:none' : '']"
                            )
                            | {{item.name}}
                            span.redAst(v-if="(schema.required === true && schema.elementAsterisk === true)") *
                template(v-if="schema.radioType === 'squareCross' || schema.radioType === 'squareHook'")
                    div.radioSingleItem(:class="schema.inline === true ? `${schema.size}` : 'col-12'" v-for="item, index in schema.values")
                        label.smallLabel.d-flex.justify-content-start(
                            :for="`${id}_${index}`" 
                            :style="[disabled === true ? 'pointer-events:none' : '']"
                        )
                            .col-auto
                                span(:class="schema.borderClass" :style="`margin-right:${schema.marginBetween};position:relative; top:${schema.boxTop}px; font-size:${schema.boxFontSize}; border: ${schema.boxBorder}; border-radius:${schema.boxBorderRadius}px;padding:${schema.boxPadding};background:${schema.boxBackground};color:${schema.colorContent};`")
                                    font-awesome-icon(v-if="schema.radioType === 'squareHook'" icon="fa-solid fa-check" :style="[isInModel(item.id) === false ? 'opacity:0' : '']")
                                    font-awesome-icon(v-if="schema.radioType === 'squareCross'" icon="fa-solid fa-xmark" :style="[isInModel(item.id) === false ? 'opacity:0' : '']")
                            div(:class="schema.checkBoxText")
                                div(style="margin-left: 5px") 
                                    | {{item.name}}
                                    span.redAst(v-if="(schema.required === true && schema.elementAsterisk === true)") *
                            input(
                                type="radio" 
                                :name="schema.model" 
                                :value="item.id" 
                                :id="`${id}_${index}`"
                                v-model="model[schema.model]"
                                :class="schema.errorShow === true ? 'inputred' : ''"
                                style="appearance: none; -webkit-appearenace:none;"
                            ) 
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
        .vueFormSmall.labelred(v-if="schema.errorShow === true")
            font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
            | &nbsp;{{ schema.errorText[0] }}
</template>